import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for the `promotions` collection (supports drafts).
 */
export const promotionsLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) => `${serverURL}${apiPath}/promotions/${docId}?draft=true`
);
